import { themeVariables } from "Components/theme";
import React, { useMemo } from "react";
export default function ColorIndicator({ className, size, bgColor }) {
    const style = useMemo(() => ({
        width: size,
        height: size,
        backgroundColor: bgColor || themeVariables["gray-050"],
        border: `1px solid ${bgColor || themeVariables["gray-400"]}`,
        borderRadius: "50%"
    }), [size, bgColor]);
    return React.createElement("div", { className: className, style: style });
}
